/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IObrienPerformanceNumbers contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum performanceAnimation1 {
    p1zero = 'p1zero',
    p1one = 'p1one',
    p1two = 'p1two',
    p1three = 'p1three',
    p1four = 'p1four',
    p1five = 'p1five'
}

export const enum performanceAnimation2 {
    p2zero = 'p2zero',
    p2one = 'p2one',
    p2two = 'p2two',
    p2three = 'p2three',
    p2four = 'p2four',
    p2five = 'p2five'
}

export const enum performanceAnimation3 {
    p3zero = 'p3zero',
    p3one = 'p3one',
    p3two = 'p3two',
    p3three = 'p3three',
    p3four = 'p3four',
    p3five = 'p3five'
}

export const enum performanceAnimation4 {
    p4zero = 'p4zero',
    p4one = 'p4one',
    p4two = 'p4two',
    p4three = 'p4three',
    p4four = 'p4four',
    p4five = 'p4five'
}

export const enum performanceAnimation5 {
    p5zero = 'p5zero',
    p5one = 'p5one',
    p5two = 'p5two',
    p5three = 'p5three',
    p5four = 'p5four',
    p5five = 'p5five'
}

export interface IObrienPerformanceNumbersConfig extends Msdyn365.IModuleConfig {
    performanceTitle1?: IPerformanceTitle1Data;
    performanceAnimation1?: performanceAnimation1;
    performanceTitle2?: IPerformanceTitle2Data;
    performanceAnimation2?: performanceAnimation2;
    performanceTitle3?: IPerformanceTitle3Data;
    performanceAnimation3?: performanceAnimation3;
    performanceTitle4?: IPerformanceTitle4Data;
    performanceAnimation4?: performanceAnimation4;
    performanceTitle5?: IPerformanceTitle5Data;
    performanceAnimation5?: performanceAnimation5;
}

export const enum PerformanceTitle1Tag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IPerformanceTitle1Data {
    text: string;
    tag?: PerformanceTitle1Tag;
}

export const enum PerformanceTitle2Tag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IPerformanceTitle2Data {
    text: string;
    tag?: PerformanceTitle2Tag;
}

export const enum PerformanceTitle3Tag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IPerformanceTitle3Data {
    text: string;
    tag?: PerformanceTitle3Tag;
}

export const enum PerformanceTitle4Tag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IPerformanceTitle4Data {
    text: string;
    tag?: PerformanceTitle4Tag;
}

export const enum PerformanceTitle5Tag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IPerformanceTitle5Data {
    text: string;
    tag?: PerformanceTitle5Tag;
}

export interface IObrienPerformanceNumbersProps<T> extends Msdyn365.IModule<T> {
    config: IObrienPerformanceNumbersConfig;
}
